import { render, staticRenderFns } from "./LawyerEdit.vue?vue&type=template&id=7e28fb04&scoped=true&"
import script from "./LawyerEdit.vue?vue&type=script&lang=js&"
export * from "./LawyerEdit.vue?vue&type=script&lang=js&"
import style0 from "./LawyerEdit.vue?vue&type=style&index=0&id=7e28fb04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e28fb04",
  null
  
)

export default component.exports